<template>
    <b-card :class="['messenger', className]" no-body :border-variant="borderVariant">

        <div class="card-header bg-light">
            <div class="pl-0">
                <b-card-title>{{ $t('Component(Conversation):title', {subscriber: chat.subscriber.title}) }}</b-card-title>
            </div>
        </div>

        <div>
            <vue-perfect-scrollbar
                ref="refChatLogPS"
                :settings="perfectScrollbarSettings"
                class="scroll-area"
                :style="scrollAreaStyle"
            >
                <Messages
                    class="user-chats p-2"
                    :chat="chat"
                    :messages="messages"
                />
            </vue-perfect-scrollbar>

            <div class="p-2 bg-light">
                <b-form
                    class="chat-app-form"
                    @submit.prevent="send"
                >
                    <b-form-textarea
                        v-model="message"
                        :placeholder="$t('Component(Conversation):message-placeholder')"
                    />
                    <div class="text-right mt-1">
                        <b-button
                            variant="primary"
                            type="submit"
                            block
                        >
                            {{ $t('Component(Button):send') }}
                        </b-button>
                    </div>

                    <div class="row" v-show="false">
                        <div class="col-md-10 col-lg-10">
                            <b-form-textarea
                                v-model="message"
                                placeholder="Enter your message"
                            />
                        </div>
                        <div class="text-center pt-1 col-md-2 col-lg-2">
                            <b-button
                                variant="primary"
                                type="submit"
                                class="text-right"
                            >
                                {{ $t('Component(Button):send') }}
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </b-card>
</template>

<script>
import Messages from "./Messages"
import {
    BForm, BInputGroup, BFormInput, BFormTextarea, BButton,
    BCard, BCardTitle
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {MessengerApi} from "@core/api";
import {
    nextTick,
} from '@vue/composition-api'
import chatFactory from "@/libs/chat";

export default {
    components: {
        VuePerfectScrollbar,
        Messages, BCardTitle,
        BForm, BInputGroup, BFormTextarea, BButton, BFormInput, BCard,
    },
    props: {
        requestId: {
            default: null
        },
        height: {
            default: 300
        },
        borderVariant: {
            default: 'light'
        },
        className: {
            default: ''
        }
    },
    data() {
        return {
            perfectScrollbarSettings: {
                maxScrollbarLength: 150,
            },
            chat: {
                subscriber: {
                    title: ''
                },
            },
            messages: [],
            message: '',
            chatSubscriberId: null,
            chatInstance: null
        };
    },
    methods: {
        initByRequestId(id) {
            this.messages = [];

            const chat = this.chatInstance = chatFactory(id);
            this.chatSubscriberId = chat.subscribe(this.handleMessages);
            chat.init().then(chat => {
                this.chat = chat;
            });
        },

        handleMessages(messages) {
            messages.forEach(m => this.messages.push(m));
            nextTick(() => this.scrollToBottomInChatLog());
        },

        send() {
            if (this.message) {
                // chatFactory(this.requestId).send(this.message).then(() => {
                this.chatInstance.send(this.message).then(() => {
                    this.message = '';
                    nextTick(() => this.scrollToBottomInChatLog());
                });
            }
        },

        scrollToBottomInChatLog() {
            if (!this.$refs.refChatLogPS) {
                return;
            }
            const scrollEl = this.$refs['refChatLogPS'].$el || this.$refs['refChatLogPS'].value

            if (scrollEl) {
                scrollEl.scrollTop = scrollEl.scrollHeight
            }
        },

        retrieveNewMessages() {
            let offset = this.chat.messages.length > 0 ? this.chat.messages[this.chat.messages.length - 1].id : 0;
            MessengerApi.getUnreadMessages(this.chat.id, offset).then(r => {
                r.data.forEach(m => this.chat.messages.push(m));
                if (r.data.length > 0) {
                    nextTick(() => this.scrollToBottomInChatLog());
                }
                //this.delayNewMessagesRetrieve();
            });
        },

        delayNewMessagesRetrieve() {
            setTimeout(() => {
                this.retrieveNewMessages();
            }, 15000);
        }
    },
    mounted() {
        this.scrollToBottomInChatLog();
    },
    unmounted() {
        if (this.chatSubscriberId) {
            // chatFactory(this.requestId).unsubscribe(this.chatSubscriberId);
            this.chatInstance.unsubscribe(this.chatSubscriberId);
        }
    },
    created() {
        if (this.requestId) {
            this.initByRequestId(this.requestId);
        }
    },
    watch: {
        requestId(id) {
            this.initByRequestId(id);
        }
    },
    computed: {
        scrollAreaStyle() {
            return 'height: ' + this.height + 'px !important;';
        }
    }
}
</script>

<style lang="scss">
.scroll-area {
    position: relative;
    margin: auto;
    height: 300px;
}
.user-chats {
    background-color: white;
    height: inherit;
}
</style>
